if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    if (BSS_B2B.countryCode === "CL") {
        function hideDecimals() {
            const comparePrices = document.querySelectorAll('.bss-b2b-compare-price-no-vat');
            const prices = document.querySelectorAll('.bss-b2b-price-no-vat');
            const comparePricesVat = document.querySelectorAll('.bss-b2b-compare-price-has-vat');
            const pricesVat = document.querySelectorAll('.bss-b2b-price-has-vat');

            const priceBlocks = document.querySelectorAll('.price[bss-b2b-product-price], .product-option[bss-b2b-item-original-price], .cart-item__price-wrapper[bss-b2b-final-line-price], .totals__total-value[bss-b2b-cart-total-price]');

            priceBlocks.forEach(block => {
                const spans = block.querySelectorAll('span');
                spans.forEach(span => {
                    if (span.dataset.decimalHidden) return;

                    let text = span.textContent;

                    // Nếu là compare price (có line-through)
                    if (span.style.textDecoration.includes('line-through')) {
                    text = text.replace(/(\$[\d,]+)\.\d+/g, '$1');
                    } 
                    // Regular price -> làm tròn
                    else {
                    text = text.replace(/\$([\d,]+)\.(\d+)/g, (match, dollars, cents) => {
                        let amount = parseInt(dollars.replace(/,/g, ''));
                        if (parseInt(cents) >= 50) {
                        amount += 1;
                        }
                        return '$' + amount.toLocaleString('en-US');
                    });
                    }

                    span.textContent = text;
                    span.dataset.decimalHidden = 'true';
                });
            });
            
            // Xử lý compare prices - chỉ ẩn thập phân
            comparePrices.forEach(element => {
                if (!element.dataset.decimalHidden) {
                    let text = element.textContent;
                    text = text.replace(/(\$[\d,]+)\.\d+/g, '$1');
                    element.textContent = text;
                    element.dataset.decimalHidden = 'true';
                }
            });
            
            // Xử lý regular prices - làm tròn
            prices.forEach(element => {
                if (!element.dataset.decimalHidden) {
                    let text = element.textContent;
                    // Làm tròn: .50 trở lên thì tròn lên, dưới .50 thì tròn xuống
                    text = text.replace(/\$([\d,]+)\.(\d+)/g, (match, dollars, cents) => {
                        let amount = parseInt(dollars.replace(/,/g, ''));
                        if (parseInt(cents) >= 50) {
                            amount += 1;
                        }
                        return '$' + amount.toLocaleString('en-US');
                    });
                    element.textContent = text;
                    element.dataset.decimalHidden = 'true';
                }
            });

            // VAT
            // Xử lý comparePricesVat - chỉ ẩn thập phân
            comparePricesVat.forEach(element => {
                if (!element.dataset.decimalHidden) {
                    let text = element.textContent;
                    text = text.replace(/(\$[\d,]+)\.\d+/g, '$1');
                    element.textContent = text;
                    element.dataset.decimalHidden = 'true';
                }
            });
            
            // Xử lý regular pricesVat - làm tròn
            pricesVat.forEach(element => {
                if (!element.dataset.decimalHidden) {
                    let text = element.textContent;
                    // Làm tròn: .50 trở lên thì tròn lên, dưới .50 thì tròn xuống
                    text = text.replace(/\$([\d,]+)\.(\d+)/g, (match, dollars, cents) => {
                        let amount = parseInt(dollars.replace(/,/g, ''));
                        if (parseInt(cents) >= 50) {
                            amount += 1;
                        }
                        return '$' + amount.toLocaleString('en-US');
                    });
                    element.textContent = text;
                    element.dataset.decimalHidden = 'true';
                }
            });
        }
        
        hideDecimals();
        
        // Tạo MutationObserver để theo dõi thay đổi trong DOM
        const observer = new MutationObserver((mutations) => {
            hideDecimals();
            const targetTags = ["B2B", "DIAMANTE", "ZAFIRO", "ESTUDIANTE", "OUTLET2026"];
            const tags = BSS_B2B?.shopData?.customer?.tags || []
            const hasTargetTag = tags?.some(tag => targetTags.includes(tag));

            if (hasTargetTag) {
                // console.log("B2B customer");
                showPrice();
            }
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    // Case 1: Check khi trang load lần đầu
    let counter = 0;
    const selector = "[bss-b2b-cart-total-price]";
    const interval = setInterval(() => {
        const element = document.querySelector(selector);
        if (element) {
            clearInterval(interval);
            
            setTimeout(() => {
                const targetTags = ["B2B", "DIAMANTE", "ZAFIRO", "ESTUDIANTE", "OUTLET2026"];
                const tags = BSS_B2B.shopData.customer.tags || []
                const hasTargetTag = tags.some(tag => targetTags.includes(tag));

                if (hasTargetTag) {
                    // console.log("B2B customer 1");
                    showPrice();
                }
            }, 2500);
        } else {
            counter += 100;
            if (counter >= 10000) {
                clearInterval(interval);
            }
        }
    }, 100);

    function showPrice() {
        const selector = "[bss-b2b-cart-total-price]";
        const element = document.querySelector(selector);
        
        if (!element) {
            return;
        }

        if (typeof BSS_B2B === "undefined" || !BSS_B2B) {
            return;
        }

        // Xử lý label và price trên cùng 1 dòng
        const el = document.querySelector('.totals__total-value .bss-b2b-price-no-vat');
        if (el && !el.querySelector('.label')) { // Chỉ xử lý nếu chưa được format
            const text = el.textContent.trim();
            const match = text.match(/^(\$\S+)\s+(.*)$/);
            if (match) {
                const price = match[1];
                const label = match[2];
                el.innerHTML = `
                    <span class="label">${label}</span>
                    <span class="price">${price}</span>
                `;
            }
        }

        // Logic thêm VAT info
        const priceData = BSS_B2B.shopData.cart.bss_b2b_total_priceTD;
        
        if (priceData && priceData.subtotalHasVat && priceData.subtotalNoVat) {
            // Kiểm tra xem đã thêm VAT info chưa
            if (element.querySelector('.bss-b2b-vat-amount')) {
                return;
            }

            const subtotalNoVat = priceData.subtotalNoVat / 100;
            const subtotalHasVat = priceData.subtotalHasVat / 100;
            
            // Tính % VAT
            const vatPercent = ((subtotalHasVat - subtotalNoVat) / subtotalNoVat) * 100;
            const vatAmount = subtotalHasVat - subtotalNoVat;
            
            // Format số
            const formatPrice = (amount) => {
                return '$' + Math.round(amount).toLocaleString('en-US');
            };

            // Thêm "Estimated total:"
            const container = document.querySelector('.totals__total-value');
            if (container && !container.querySelector('span[style*="padding-bottom"]')) {
                const span = document.createElement('span');
                span.textContent = 'Estimated total:';
                span.style.paddingBottom = '5px';
                container.prepend(span);
            }

            // Tạo span VAT với %
            const vatSpan = document.createElement('span');
            vatSpan.className = 'bss-b2b-vat-amount';
            vatSpan.textContent = `IVA: ${Math.round(vatPercent)}% (${formatPrice(vatAmount)})`;
            
            // Tạo span TỔNG với VAT
            const totalSpan = document.createElement('span');
            totalSpan.className = 'bss-b2b-total-with-vat';
            totalSpan.textContent = `TOTAL CON IVA: ${formatPrice(subtotalHasVat)}`;
            
            // Thêm vào element
            element.appendChild(vatSpan);
            element.appendChild(totalSpan);
        }
    }

    function formatDiscountPriceCells() {
        document.querySelectorAll(
            ".bss-b2b-cart-item-qty-table .quantity_break_table tbody tr td:nth-child(2), td [bss-b2b-final-line-price][style]"
        ).forEach(el => {
            el.innerHTML = el.innerHTML.replace(/\$[\d,]+(?:\.\d+)?/g, price =>
                BSS_B2B.formatMoney(
                    Number(price.replace(/[^\d.]/g, "")) * 100,
                    "${{amount_no_decimals}}"
                )
            );
        });
    }

    function handleDiscountFormatting() {
        if (window.location.pathname.includes("/cart")) {
            formatDiscountPriceCells();
            return;
        }

        if (window.location.pathname.includes("/products/")) {
            const productData = [...(BSS_B2B?.storage?.productFormStorage?.store?.values?.() || [])][0];

            if (productData?.appliedQB?.qb_table_type === 1) {
                formatDiscountPriceCells();
            }
        }
    }

    if (
        window.location.pathname.includes("/products/") ||
        window.location.pathname.includes("/cart")
    ) {
        const interval = setInterval(handleDiscountFormatting, 500);

        setTimeout(() => {
            clearInterval(interval);
        }, 6000);
    }

}

if (window.BSS_BCP_V2?.shop) {
    BSS_BCP_V2.shop.moneyFormat = "${{ amount_no_decimals }}";
}